import { environment } from "src/environments/environment";
import { Observable } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { GenericRepository } from "../../generic-repository/GenericRepository";
import { ResponseModel } from "../../../models/SharedModels/response.model";
import { ProductionOrder } from "../../../models/Production/productionOrder";
import { IProductionRepository } from "./IProductionRepository";
import { PORoutingHistory } from "src/app/models/Production/poRoutingHistory";

@Injectable(
    {
        providedIn: "root"
    }
)
export class ProductionRepository extends GenericRepository<ProductionOrder> implements IProductionRepository {

    url: string = environment.urlAddress;
    constructor(protected _http: HttpClient) {
        super(_http, 'api/Production', environment.urlAddress);
    }

    GetAll(currentPage: number, recordsPerPage: number, filterText: string): Observable<any> {
        filterText = filterText.split('/').join('~');
        if (filterText == "") {
            filterText = "|";
        }

        return this.Get('SelectAll' + '/' + currentPage + '/' + recordsPerPage + '/' + filterText).pipe(map(this.extractData), catchError(this.handleError));
    }

    GetAllForDashboard(productionOrderCode: string): Observable<any> {
        productionOrderCode = productionOrderCode.split('/').join('~');
        if (productionOrderCode == "") {
            productionOrderCode = "|";
        }

        return this.Get('SelectAllForDashboard' + '/' + productionOrderCode).pipe(map(this.extractData), catchError(this.handleError));
    }

    GetPOHistoryRec(productionOrderCode: string, operationSequence: number): Observable<any> {
        return this.Get('GetPOHistoryRec' + '/' + productionOrderCode + '/' + operationSequence).pipe(map(this.extractData), catchError(this.handleError));
    }

    SaveRec(item: ProductionOrder): Observable<ResponseModel> {
        return this.PostData('/SaveRec', item).pipe(map(this.extractData), catchError(this.handleError));
    }

    SavePORoutingHistoryRec(item: any): Observable<ResponseModel> {
        return this.PostData('/SavePORoutingHistoryRec', item).pipe(map(this.extractData), catchError(this.handleError));
    }

    DeleteRec(code: string): Observable<ResponseModel> {
        return this.Delete('/DeleteRec/' + code).pipe(map(this.extractData), catchError(this.handleError));
    }

    NavRec(navType: number, currentIndex: number): Observable<ResponseModel> {
        return this.Get('NavRec/' + navType + '/' + currentIndex).pipe(map(this.extractData), catchError(this.handleError));
    }

    GetRec(code: string): Observable<ResponseModel> {
        return this.Get('GetRec/' + code).pipe(map(this.extractData), catchError(this.handleError));
    }
    SelectPOByID(code: string): Observable<ResponseModel> {
        return this.Get('SelectPOByID/' + code).pipe(map(this.extractData), catchError(this.handleError));
    }
}